import { formatCustomDate } from "helpers/dateTools"

export const SURVEY_STATION = "SURVEY_STATION"
export const SET_SURVEYS = "SET_SURVEYS"
export const SET_SURVEY = "SET_SURVEY"
export const SET_SURVEY_FILTERS = "SET_SURVEY_FILTERS"

const initialState = {
  surveys: [],
  survey: {},
  station: null,
  startDate: formatCustomDate(new Date(), '-'),
  endDate: formatCustomDate(new Date(), '-'),
}

const colorPercent = (num1, num2) => {
  const totalSum = num1 + num2;
  const percent = (num2 / totalSum) * 100;

  if (percent <= 30) {
    return 'good';
  } else if (percent <= 50) {
    return 'regular';
  } else if ( totalSum === 0 ) {
    return '';
  } else {
    return 'bad'
  }
};

export const surveysReducer = (state = initialState, { type, payload }) => {
  switch (type) {

    case SET_SURVEY_FILTERS: {
      // Al cambiar cualquier filtro se limpia la tabla, para que el Excel no se descargue con filtros distintos a los mostrados
      const surveys = ["station", "startDate", "endDate"].includes(payload.key) ? [] : state.surveys
      return {
        ...state,
        [payload.key]: payload.value,
        surveys,
      }
    }

    case SET_SURVEYS: {
      const newPayload = payload.length > 0 ? payload.map(surv => {
        return {
          ...surv,
          unitNumber: surv.unit.number,
          driver: surv.unit.driver.name,
          survey: surv.typeSurvey.name,
          status: surv.mappedStatus.name,
          statusColor: surv.mappedStatus.color,
        }
      }) : payload
      return {
        ...state,
        surveys: newPayload
      }
    }

    case SET_SURVEY: {
      const questionsGroupsCounting = payload.questionGroups.map(group => {
        let positive = 0
        let negative = 0
        let na = 0
        return {
          ...group,
          questions: group.questions.map(question => {
            const answer = question?.answer.toLowerCase();
            switch (answer) {
              case "si":
                positive++;
                break;
              case "no":
                negative++;
                break;
              case "bien":
                positive++;
                break;
              case "mal":
                negative++;
                break;
              case "n/a":
                na++;
                break;
              default:
                break;
            }
            return question
          }),
          positive: positive,
          negative: negative,
          notApply: na,
          colorStatus: positive > negative ? '#4caf50' : '#f6685e',
          bgColor: colorPercent(positive, negative)
        }
      })
      const nPayload = {
        ...payload,
        questionGroups: questionsGroupsCounting
      }

      return {
        ...state,
        survey: nPayload
      }
    }

    default:
      return state;
  }
}